
import { Image, get_prop } from 'utils'
import { TYPE } from 'network/server_tool'
import { Animation } from 'animation'
import { REQUEST_TYPE } from 'network/net'

import {to_literal_text} from'./ui_view';

function betLineToSymbolText(price ,lines) {
    const whole = Math.floor( price / lines )
    let nom = price % lines
    let de = lines
    const div = gcd( nom, de )
    nom /= div
    de /= div
    const fraction = nom ? '%d/%d'.$( nom, de ) : ''

    return ( whole <= 0 ? '' : ( whole.toString() + ' ' ) ) + fraction;
}

//форматирует строку времени вида yyyy-mm-dd hh:mm:ss.ms+UTC
// в строку вида (16:52:42.055 (время местное, UTC+03) 18 сен 2019)
export function formatTimeString(timeString) {

    // console.log('FORMATE TIME', timeString);

    if (!timeString) {
        return;
    }

    const nameMonth = {
        '01': ' янв ',
        '02': ' фев ',
        '03': ' мар ',
        '04': ' апр ',
        '05': ' май ',
        '06': ' июн ',
        '07': ' июл ',
        '08': ' авг ',
        '09': ' сен ',
        '10': ' окт ',
        '11': ' ноя ',
        '12': ' дек ',
    };

    let year = timeString.substring(0, timeString.indexOf('-'));

    let md = timeString.match(/-\d\d/g);
    let month = md[0].substr(1);
    let day = md[1].substr(1);

    let match = timeString.match(/\+\d\d/g)
    let utc = match ? match[0] : '';

    match = timeString.match(/\d\d:\d\d:\d\d/g)
    let timeWithoutMS = match ? match[0] : '';

    match = timeString.match(/\.\d+/g)
    let ms = match ? match[0] : '';
    if (ms.length < 4) {
        for (let i = ms.length; i < 4; ++i) {
            ms += '0';
        }
    }
    let time = timeWithoutMS + ms;

    let result = time + ' (время местное, UTC' + utc + ') ' + day + nameMonth[month] + year;

    return result;

}

export default function( space, container, spec, settings )
{
    container.interactiveChildren = false
    console.log( 'spec:', spec )
    const background = Image( settings.table.background )
    if (settings.table.background_position) {
        background.position = settings.table.background_position;
    }
    else {
        background.position.set(0, 126)
    }
    container.addChild( background )
    
    function text( t, x, y, scatter ){
        const tf = new PIXI.extras.BitmapText( t.toString(), { font : 'coeff_tab_digits', align: "right" } )
        
        space.s( 'ui:betValue' ).on( ({ lines }) => {
            if ( scatter ) lines = 1
            
            tf.text = betLineToSymbolText(t, lines);
        } )
        
        tf.anchor.set( 1, 0 )
        tf.position.set( x, y )
        container.addChild( tf )
    }

    const Y_DELTA = 15
    function text_array( array, x, y, scatter ) {
        for ( const ti in array ) text(
            array[ ti ],
            x,
            y + Y_DELTA * ti,
            scatter,
        )
    }

    const scatterPrice = settings.table.scatterPrice;
    text_array(
        spec.specification.scatterWinCoeffs.slice( scatterPrice.wins[ 0 ] ),
        scatterPrice.position.x,
        scatterPrice.position.y,
        true,
    )
    const priceTable = settings.table.priceTable;
    for ( const price of priceTable ) {
        text_array(
            spec.specification.priceList[ price.symbol ].slice( price.wins[ 0 ] ),
            price.position.x,
            price.position.y,
        )
    }

    if ( settings.table.combinationNameFormat ) {
        const lines = []
        const LINES_Y = [ 173, 265, 360, 453, 547 ]
        function line( i ) {
            const l = Image( settings.table.combinationNameFormat.$( i ) )
            l.position.set( 44, LINES_Y[ i ] )
            container.addChild( l )
            lines.push( l )
        }
        line( 0 )
        line( 1 )
        line( 2 )
        line( 3 )
        line( 4 )
        space.s( 'ui:resultBet' ).on( ({ bet }) => {
            for ( const l of lines ) l.visible = false
            lines[ bet.lines ].visible = true
        } )
    }
    
    cheque( space, container, spec, settings )
}

function gcd(a, b) {
    if (b) {
        return gcd(b, a % b);
    } else {
        return Math.abs(a);
    }
}

function text( container, pos, align, size = 12 ) {
    const t = new PIXI.Text(
        '',
        {
            fontSize : size,
            fill : 0x000000,
            align : align || 'center',
            fontWeight : 'bold',
        },
    )
    t.anchor.set( 0.5 )
    t.position.set( pos[ 0 ], pos[ 1 ] )
    container.addChild( t )
    return t
}

export function is_cheque( state ) {
    return [ TYPE.REGULAR, TYPE.FREESPIN, TYPE.FINISH, TYPE.FINAL ].includes( state.type )
}
export function destroy( d ) {
    for ( const t of d ) t.destroy( { children : true } )
    d.length = 0
}

function cheque( space, container, spec, settings )
{
    const view = new PIXI.Container
    container.addChild( view )
    view.visible = false;

    space.s( 'pending' )
        .filter(pending => pending == REQUEST_TYPE.SPIN)
        .on(() => {
            view.visible = false;
            frames.forEach(f => f.visible = false);
            scatterFrame.visible = false;
        });

    space.s( 'slot:linesChange' )
        .on(() => {
            view.visible = false;
            frames.forEach(f => f.visible = false);
            scatterFrame.visible = false;
        });

    space.s( 'state' )
        .filter(state => state.type == TYPE.FINAL)
        .on((state) => { showCheck(state.state.stage.math.symbols) });

    space.s( 'sportbet:main_mini_balls:end_roll' )
        .with(space.s('state'), (_, state) => state)
        .on((state) => { showCheck(state.state.stage.math.symbols) });
    
    const check = Image( 'res/games/cheque/chek.png' )
    check.position.set( 187, 156 )
    view.addChild( check )
    
    const number = text( view, [ 450, 176 ], 'left', 16 )
    number.anchor.set( 0, 0.5 )
    number.text = settings.cheque.pari
    const step = text( view, [ 455, 228 ], 'left' )
    const event = text( view, [ 419, 244 ] )
    event.anchor.set( 0.5 )
    const time = text( view, [ 418, 282 ] )
    const step_time = text( view, [ 421, 439 ] )
    const step_win = text( view, [ 421, 453 ] )
    const step_lines = text( view, [ 422, 468 ] )
    const comp_time = text( view, [ 421, 523 ] )

    const step_result = text( view, [421, 534]);
    const step_details = text( view, [421, 545]);

    space.s( 'state' )
        .with(space.s('balance'), space.s( 'math' ),  (state, balance, math, bet) => ({state, balance, math}))
        .on( ({state, balance, math}) => {

            let eventName = (state.type && (state.type == TYPE.FREEGAME)) ? settings.cheque.freegame_event : settings.cheque.event;

            const s = state.state
            step.text = get_prop( s, [ 'math_info', 'bet_id' ], '940.000004393796' )
            event.text = eventName + ' №' + get_prop( s, [ 'math_info', 'source', 'id' ] )
            time.text = formatTimeString(get_prop( s, [ 'math_info', 'source', 'created' ], '' ).toString())
            step_time.text = formatTimeString(get_prop( s, [ 'math_info', 'created' ], '' ).toString())
            step_win.text = 'Размер шага, баллов: %s.00'.$( s.line_count * s.multiplier );
            step_lines.text = 'Игра на комбинацию № %d'.$( s.line_count )
            comp_time.text = formatTimeString(get_prop( s, [ 'math_info', 'computed' ], '' ).toString());

            if (state.state.stage.win) {
                let win = state.state.stage.win * state.state.multiplier;
                step_result.text = 'Результат шага, баллов: ' + to_literal_text(win, balance);

                let lines = state.state.line_count;
                let detail_string = '';
                let winLines = math.winLines();
                let bet = to_literal_text(lines * state.state.multiplier, balance);
                for (let i = 0; i < winLines.length; ++i) {
                    let symbol = math.lineWinSymbol(winLines[i]);
                    let symbolCount = math.lineWinPositions(winLines[i]).length;
                    let price = spec.specification.priceList[symbol][symbolCount];

                    if (i > 0) {
                        detail_string += '+';
                    }
                    detail_string += '(' + bet + '*' + betLineToSymbolText(price, lines) + ')';
                }

                if (math.scatterWin()) {
                    if (winLines.length > 0) {
                        detail_string += '+';
                    }
                    let price = spec.specification.scatterWinCoeffs[math.scatterPositions().length];
                    detail_string += '(' + bet + '*' + betLineToSymbolText(price, 1) + ')';
                }

                step_details.text = detail_string;
            }
            else {
                step_result.text = 'Результат шага отсутсвует.';
                step_details.text = '';
            }
        } )

    const BALL_X = 171
    const BALL_Y = 155
    const BALL_D_X = 41
    const BALL_D_Y = 28

    const circles = [];
    const frames = [];

    for (let line = 0; line < spec.specification.linesCountMax; ++line) {
        let lineSpec = spec.specification.linesPaths[line];
        let circleLine = [];
        for (let col = 0; col < 5; ++col) {
            let row = lineSpec[col];
            let circle = Image( settings.table.coloursCircleNameFormat.$( line ) );
            circle.visible = false;
            circleLine.push( circle )
            circle.position.set( BALL_X + col * BALL_D_X - 13, BALL_Y + row * BALL_D_Y - 6 );
            check.addChild( circle )
        }
        circles.push(circleLine);

        let frame = Image( settings.table.frameNameFormat.$( line ) );
        frame.visible = false;
        frames.push(frame);

        container.addChild( frame );
    }

    const scatterCirlcle = [];
    for (let col = 0; col < 5; ++col) {
        let circle = Image( settings.table.scatterCircleName );
        circle.visible = false;
        scatterCirlcle.push( circle )
        circle.position.set( BALL_X + col * BALL_D_X - 13, BALL_Y );
        check.addChild( circle )
    }
    const scatterFrame = Image( settings.table.scatterFrameName );
    scatterFrame.visible = false;
    container.addChild(scatterFrame);

    const balls = [];

    for (let b = 0; b < 15; ++b) {
        const pos = symbol_index_to_pos( b )
        let ball = new PIXI.extras.BitmapText('', { font : 'digits_ishod', align: "center" });
        ball.anchor.set(0.5, 0.0);
        balls.push( ball )
        ball.position.set( BALL_X + pos.col * BALL_D_X, BALL_Y + pos.row * BALL_D_Y );
        check.addChild( ball );
    }

    const showCheck = (symbols) => {

        balls.forEach((b, id) => {
            b.text = symbols[id];
        });

        for (let id = 0; id < circles.length; ++id) {
            circles[id].forEach(c => c.visible = false);
        }
        scatterCirlcle.forEach(sc => sc.visible = false);

        frames.forEach(f => f.visible = false);
        scatterFrame.visible = false;

        view.visible = true;//check.visible = true;
    }

    const FRAME_X_1 = 793 - 4
    const FRAME_X_2 = FRAME_X_1 + 185 + 2
    const FRAME_D_X = 15

    space.s( 'presenter:play_line' )
        .with( space.s( 'math' ), ( lo, math ) => ({ line : math.winLines()[ lo ], math }) )
        .filter(({line}) => line !== undefined)
        .on( ({ line, math }) => {

            for (let i = 0; i < frames.length; ++i) {
                if (i === line) {
                    const symbol = math.lineWinSymbol( line );
                    const priceWins = settings.table.priceTable.filter(p => p.symbol === symbol)[0].wins;
                    const priceLine = priceWins.indexOf(math.lineWinPositions( line ).length);
                    frames[i].position.set(
                        ( symbol % 2 ) == 0 ? FRAME_X_1 : FRAME_X_2,
                        settings.table.frameYPos[ Math.floor( symbol / 2 ) ] + FRAME_D_X * priceLine
                    )
                    frames[i].visible = true;
                }
                else {
                    frames[i].visible = false;
                }
                scatterFrame.visible = false;
            }

            for (let id = 0; id < circles.length; ++id) {
                circles[id].forEach(c => c.visible = false);
            }
            scatterCirlcle.forEach(sc => sc.visible = false);
            const win_pos = math.lineWinPositions( line );
            for ( let i = 0; i < win_pos.length; ++i ) {
                let wp = win_pos[i];
                const pos = symbol_index_to_pos( wp );
                let c = circles[line][i];
                c.position.set( BALL_X + pos.col * BALL_D_X - 13, BALL_Y + pos.row * BALL_D_Y - 6 )
                c.visible = true;
            }

        } )

    space.s( 'presenter:play_scatters' )
        .filter(play => play)
        .with( space.s( 'math' ), ( scatter, math ) => math )
        .filter(math => math.scatterWin() > 0)
        .on(math => {

            frames.forEach(f => f.visible = false);

            const symbol = math.scatter;
            const priceWins = settings.table.scatterPrice.wins;
            const priceLine = priceWins.indexOf(math.scatterPositions().length);
            scatterFrame.position.set(
                ( symbol % 2 ) == 0 ? FRAME_X_1 : FRAME_X_2,
                settings.table.frameYPos[ Math.floor( symbol / 2 ) ] + FRAME_D_X * priceLine
            )
            scatterFrame.visible = true;

            for (let id = 0; id < circles.length; ++id) {
                circles[id].forEach(c => c.visible = false);
            }
            scatterCirlcle.forEach(sc => sc.visible = false);
            let scatter_pos = math.scatterPositions();
            for ( let i = 0; i < scatter_pos.length; ++i ) {
                let index = scatter_pos[i];
                const pos = symbol_index_to_pos( index );
                let c = scatterCirlcle[i];
                c.position.set( BALL_X + pos.col * BALL_D_X - 13, BALL_Y + pos.row * BALL_D_Y - 6 )
                c.visible = true;
            }
    });
}

export function symbol_index_to_pos( i ) {
    return {
        col : Math.floor( i / 3 ),
        row : i % 3,
    }
}










// WEBPACK FOOTER //
// ./src/games/table.es6